export const PROMOTION_MESSAGES_SUCCESS = {
  SAVE_SUCCESS: "Promoción guardada exitosamente.",
  DISABLE_SUCCESS: "Promoción deshabilitada exitosamente.",
  ENABLE_SUCCESS: "Promoción habilitada exitosamente.",
};

export const PROMOTION_MESSAGES_ERROR = {
  SAVE_ERROR:
    "Error al guardar la promoción. Por favor, inténtalo de nuevo.",
  DISABLE_ERROR:
    "Error al deshabilitar la promoción. Por favor, inténtalo de nuevo.",
  ENABLE_ERROR:
    "Error al habilitar la promoción. Por favor, inténtalo de nuevo.",
};
